import { Component } from '@angular/core';
import { TenureBaseComponent } from '../tenure-base/tenure-base.component';
import { SearchConfig } from '../../../model/api.model';
import { DataTableSchema } from '../../../model/dynamic-data-table.model';
import { Props, DynamicFormArray } from '../../../model/form.model';
import { LexusGrantTenureTitle, LexusGrantTenureProps, LexusGrantTenureFilterSchema, LexusGrantTenureTableSchema, LexusGrantTenureSearchConfig } from '../../../model/tenure/lexus-grant-tenure.model';
import { PageContainerComponent } from '../../../layout/page-container/page-container.component';
import { FieldNames } from '../../../model/form-fields.model';
import { PaginatorService } from '../../../services/paginator-service.service';

@Component({
  selector: 'app-lexus-grant-tenure',
  standalone: true,
  imports: [PageContainerComponent],
  providers: [PaginatorService],
  templateUrl: './lexus-grant-tenure.component.html',
  styleUrl: './lexus-grant-tenure.component.scss'
})
export class LexusGrantTenureComponent extends TenureBaseComponent {

  protected override data: string = LexusGrantTenureTitle;
  protected override props: Props = LexusGrantTenureProps;
  protected override filterSchema: DynamicFormArray = structuredClone(LexusGrantTenureFilterSchema);
  protected override dataTableSchema: DataTableSchema = structuredClone(LexusGrantTenureTableSchema);
  protected override searchConfig: SearchConfig = structuredClone(LexusGrantTenureSearchConfig);

  override onResetClicked = () => {
    const areaRegion = this.filterSchema.FieldsArray.find(x => x.fieldName === FieldNames['Area']);
    if (areaRegion) {
      areaRegion['displayName'] = 'Area / Region'
      areaRegion['selectedValue'] = '';
      areaRegion['options'] = [...structuredClone(this.regionOption)]
    }
    this.filterSchema.FieldsArray = this.filterSchema.FieldsArray.map((field) => ({ ...field, selectedValue: field['defaultValue'] ? field['defaultValue'] : '' }));
    this.dataTableSchema.dataSource = [];
    this.resetSorting()
    this.dataTableSchema.inputFilter = '';
    this.checkForAnyEmptyFields();
  }
}
